// ¯\_(ツ)_/¯
export enum CompanionAddressType {
    HouseholdAddress = 0,
    OwnAddress = 1
}